import { useContext } from 'react';

import { TimeseriesChartValueRepresentation } from '../context/TimeseriesChartValueRepresentation.context.js';

export const useValueRepresentation = () => {
  const context = useContext(TimeseriesChartValueRepresentation);

  if (context === undefined) {
    throw new Error(
      'useValueRepresentation must be used within a TimeseriesChartValueRepresentation',
    );
  }

  return context;
};
